import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_email_gold",
  "use": "icon-icon_email_gold-usage",
  "viewBox": "0 0 22.736 18.327",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22.736 18.327\" id=\"icon-icon_email_gold\">\n  <path id=\"icon-icon_email_gold_np_email_5520895_000000\" d=\"M21.28,26.42l9.143-4.586v10.5a1.888,1.888,0,0,1-1.885,1.886H9.572a1.887,1.887,0,0,1-1.885-1.886v-10.5L16.83,26.42a4.918,4.918,0,0,0,4.45,0Zm7.259-10.526H9.572A1.887,1.887,0,0,0,7.687,17.78v2.105l9.922,4.978a3.2,3.2,0,0,0,2.891,0l9.922-4.978V17.78a1.886,1.886,0,0,0-1.884-1.886Z\" transform=\"translate(-7.687 -15.894)\" fill=\"#a19568\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/icon_email_gold.svg
// module id = 138
// module chunks = 0 1 2